/**
 * @generated SignedSource<<4ec4ef3d5d259c424788f00269d2b1ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CloudApiFileUsageFileUsageReason = "DEFAULT" | "RELEASED_BY_CUSTOMER" | "UNKNOWN" | "%future added value";
export type FlightReleaseStatusEnum = "FULLY_RELEASED" | "NOT_RELEASED" | "PARTIALLY_RELEASED" | "%future added value";
export type fileusagereason = "DEFAULT" | "RELEASED_BY_CUSTOMER" | "UNKNOWN" | "%future added value";
export type changeFlightDataFilesAccessRulesMutation$variables = {
  fileIds?: ReadonlyArray<string | null> | null;
  fileUsage?: CloudApiFileUsageFileUsageReason | null;
  flightIds?: ReadonlyArray<string | null> | null;
  nonCji?: boolean | null;
};
export type changeFlightDataFilesAccessRulesMutation$data = {
  readonly changeFlightDataFilesAccessRules: {
    readonly dataFiles: ReadonlyArray<{
      readonly fileUsage: fileusagereason;
      readonly id: string;
      readonly isCji: boolean;
    } | null> | null;
    readonly errors: ReadonlyArray<string | null> | null;
    readonly flights: ReadonlyArray<{
      readonly cjiStatus: FlightReleaseStatusEnum | null;
      readonly dataFiles: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly fileUsage: fileusagereason;
            readonly id: string;
            readonly isCji: boolean;
          } | null;
        } | null>;
      } | null;
      readonly fileReleaseStatus: FlightReleaseStatusEnum | null;
      readonly id: string;
    } | null> | null;
  } | null;
};
export type changeFlightDataFilesAccessRulesMutation = {
  response: changeFlightDataFilesAccessRulesMutation$data;
  variables: changeFlightDataFilesAccessRulesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fileIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fileUsage"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "flightIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nonCji"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileUsage",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isCji",
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "fileIds",
        "variableName": "fileIds"
      },
      {
        "kind": "Variable",
        "name": "fileUsage",
        "variableName": "fileUsage"
      },
      {
        "kind": "Variable",
        "name": "flightIds",
        "variableName": "flightIds"
      },
      {
        "kind": "Variable",
        "name": "nonCji",
        "variableName": "nonCji"
      }
    ],
    "concreteType": "ChangeFlightDataFilesAccessRules",
    "kind": "LinkedField",
    "name": "changeFlightDataFilesAccessRules",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Flight",
        "kind": "LinkedField",
        "name": "flights",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileReleaseStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cjiStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FlightDataFileConnection",
            "kind": "LinkedField",
            "name": "dataFiles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FlightDataFileEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlightDataFile",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FlightDataFile",
        "kind": "LinkedField",
        "name": "dataFiles",
        "plural": true,
        "selections": (v5/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "changeFlightDataFilesAccessRulesMutation",
    "selections": (v6/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "changeFlightDataFilesAccessRulesMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "5be3dec24a1165ee602133d8dcba6821",
    "id": null,
    "metadata": {},
    "name": "changeFlightDataFilesAccessRulesMutation",
    "operationKind": "mutation",
    "text": "mutation changeFlightDataFilesAccessRulesMutation(\n  $flightIds: [ID]\n  $fileIds: [ID]\n  $fileUsage: CloudApiFileUsageFileUsageReason\n  $nonCji: Boolean\n) {\n  changeFlightDataFilesAccessRules(flightIds: $flightIds, fileIds: $fileIds, fileUsage: $fileUsage, nonCji: $nonCji) {\n    errors\n    flights {\n      id\n      fileReleaseStatus\n      cjiStatus\n      dataFiles {\n        edges {\n          node {\n            id\n            fileUsage\n            isCji\n          }\n        }\n      }\n    }\n    dataFiles {\n      id\n      fileUsage\n      isCji\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "106c6c82887dfc774d9146eaca22f8fd";

export default node;
